export default "__VITE_ASSET__BDR8uFp___"